import { PLAN_STAGES } from '@shared/schema';

export function normalizeAnnualPlanStatusFilterOptions(statuses: string[]): string[] {
  const normalized: string[] = [];
  let hasDefinition = false;

  statuses.forEach((status) => {
    if (status === PLAN_STAGES.DEFINITION || status === PLAN_STAGES.DEFINITION_OUT_OF_TIME) {
      if (!hasDefinition) {
        normalized.push(PLAN_STAGES.DEFINITION);
        hasDefinition = true;
      }
      return;
    }
    if (!normalized.includes(status)) normalized.push(status);
  });

  return normalized;
}
